// import Vue from 'vue'
// import Router from 'vue-router'
// //
// Vue.use(Router)

// export default new Router({
const router = new VueRouter({
	mode: 'history',
	routes: [{
		path: '/',
		name: 'home',//主页面
		component:  resolve => require(['../view/home/home.vue'], resolve),//懒加载
		redirect: '/index', //首页
		meta:{
			keepAlive:true
		} ,
		children: [{
			path: 'index',
			component:  resolve => require(['../view/home/index/index.vue'], resolve)//懒加载
		},
      {
			path: 'introduction',//医院简介
			component:  resolve => require(['../view/home/introduction.vue'], resolve),//懒加载
			meta:{keepAlive:true}
		}, {
			path: 'dept',//科室导航
			component:  resolve => require(['../view/home/dept.vue'], resolve),//懒加载
			meta:{keepAlive:true}
		}, {
			path: 'inquiry',//线上问诊
			component:  resolve => require(['../view/home/inquiry.vue'], resolve),//懒加载
			meta:{keepAlive:true}
		}, {
			path: 'transparency',//院务公开
			component:  resolve => require(['../view/home/transparency.vue'], resolve)//懒加载
		},
      {
        path: 'news',//新闻资讯
        component:  resolve => require(['../view/home/news/news.vue'], resolve),//懒加载
        meta:{keepAlive:true}
      }, {
        path: 'newsdetail',//新闻详情
        component:  resolve => require(['../view/home/news/news-detail.vue'], resolve),//懒加载
        meta:{keepAlive:true}
      },
      {
        path: 'dynamic',//新闻资讯
        component:  resolve => require(['../view/dynamic-detail.vue'], resolve),//懒加载
        meta:{keepAlive:true}
      }, {
        path: 'product',//付费产品-医疗行业资讯
        component:  resolve => require(['../view/home/product.vue'], resolve),//懒加载
        meta:{keepAlive:true}
      }, ]
	},{
		path: '/join',//注册页面
		name: 'join',
		component:  resolve => require(['../view/join.vue'], resolve)//懒加载
	},
    {
		path: '/err',//报错页面
		name: 'err',
		component:  resolve => require(['../view/err.vue'], resolve)//懒加载
	}],
	linkExactActiveClass: 'router-link-active',
	linkActiveClass: 'is-active',
	scrollBehavior(to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		}
	},
})

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

// 全局路由守卫
//main.js
//to:跳转到的路由 from:从哪个路由离开  next:显示函数

router.beforeEach((to, from, next) => {
	//判断条件
	//根据条件限制路由显示
	if (to.path === '/Personal') {
 		next('/Login');
	} else {
		// alert("请先登录");
		next();
	}
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js